export const PageHero = ({ kicker, title, copy, children }) => (
  <section data-testid={`page-hero-${kicker?.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="grain bg-atlantic py-20 lg:py-28">
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">{kicker}</p>
      <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl">
        {title}
      </h1>
      {copy && <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{copy}</p>}
      {children}
    </div>
  </section>
);
